import { Container } from '@/components/container'
import { Link } from '@/components/link'
import { aiFounderGithubDigestPath, aiPrSummaryVsStandupPath, asyncStandupPath, changelogPath, dailyStandupCostPath, digestExamplesPath, githubDigestPath, meetingWastePath, replaceStandupsPath, standupBotsPath, whatIsAGithubDigestPath } from '@/routes'
import { ThemeToggle } from './theme-toggle'

function FooterLink(props: React.ComponentPropsWithoutRef<typeof Link>) {
  return (
    <Link
      {...props}
      className="text-muted-foreground hover:text-foreground hover:decoration-golden-500 text-sm transition-colors hover:underline hover:underline-offset-4"
    />
  )
}

function Copyright() {
  return (
    <div className="text-muted-foreground text-sm">
      &copy; {new Date().getFullYear()} Git Digest. All rights reserved.
    </div>
  )
}

export function Footer() {
  return (
    <footer className="bg-muted/50 py-8">
      <Container>
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row md:gap-0">
          <div className="flex flex-col items-center gap-2 md:flex-row md:gap-4">
            <ThemeToggle className="ml-auto" />
            <Copyright />
          </div>
          <nav className="flex flex-wrap justify-center gap-x-4 gap-y-2">
            <FooterLink href={meetingWastePath()}>Meeting Cost Calculator</FooterLink>
            <FooterLink href={dailyStandupCostPath()}>Daily Standup Cost</FooterLink>
            <FooterLink href={asyncStandupPath()}>Async Standup</FooterLink>
            <FooterLink href={standupBotsPath()}>Standup Bots</FooterLink>
            <FooterLink href={githubDigestPath()}>GitHub Digest</FooterLink>
            <FooterLink href={whatIsAGithubDigestPath()}>What Is a GitHub Digest</FooterLink>
            <FooterLink href={aiFounderGithubDigestPath()}>Founder GitHub Digest</FooterLink>
            <FooterLink href={aiPrSummaryVsStandupPath()}>AI PR Summary</FooterLink>
            <FooterLink href={replaceStandupsPath()}>Replace Standups</FooterLink>
            <FooterLink href={digestExamplesPath()}>Digest Examples</FooterLink>
            <FooterLink href={changelogPath()}>Changelog</FooterLink>
            <FooterLink href="/terms">Terms</FooterLink>
            <FooterLink href="/privacy">Privacy</FooterLink>
            <FooterLink href="mailto:support@gitdigest.ai" target="_blank">
              Contact
            </FooterLink>
          </nav>
        </div>
      </Container>
    </footer>
  )
}
